import { render } from "./Uploadpage.vue?vue&type=template&id=03defdc1&scoped=true&ts=true"
import script from "./Uploadpage.vue?vue&type=script&lang=ts"
export * from "./Uploadpage.vue?vue&type=script&lang=ts"

import "./Uploadpage.vue?vue&type=style&index=0&id=03defdc1&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/democratielab-speech/democratielab-speech/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03defdc1"]])

export default __exports__